import { axiosInstance } from "../../axios-Instance";
import { getLoginToken } from "../../storage";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../react-query/constants";

async function getService() {
  const data = await axiosInstance({
    url: "/service",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function getMyService() {
  const data = await axiosInstance({
    url: "/service/me",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createService = async (formData: any) => {
  const data = await axiosInstance({
    url: "/service",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateService = async (formData: any) => {
  const data = await axiosInstance({
    url: `/service/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteService = async (formData: any) => {
  const data = await axiosInstance({
    url: `/service/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useService() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.service],
    queryFn: () => getService(),
  });
  return data;
}
export function useMyService() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.service, "personal"],
    queryFn: () => getMyService(),
  });
  return data;
}

export function useCreateService() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createService(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.service]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateService() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateService(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.service]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteService() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteService(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.service]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
